 $(document).ready(function () {



    function slider(){
       $(".media-gallery__grid").slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                arrows: true,
                dots: true,
                prevArrow: `
                    <button type="button" class="slick-prev custom-arrow">
                        <svg class="size-8" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M14.0962 16.7175C13.901 16.9128 13.5844 16.9128 13.3891 16.7175L9.14648 12.4749C8.95122 12.2796 8.95122 11.963 9.14648 11.7678L13.3891 7.52512C13.5844 7.32986 13.901 7.32986 14.0962 7.52512C14.2915 7.72038 14.2915 8.03696 14.0962 8.23222L10.2071 12.1213L14.0962 16.0104C14.2915 16.2057 14.2915 16.5222 14.0962 16.7175Z"
                                fill="currentColor"></path>
                        </svg>
                    </button>
                `,

                nextArrow: `
                    <button type="button" class="slick-next custom-arrow">
                        <svg class="size-8" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M10.1464 7.52512C10.3417 7.32986 10.6583 7.32986 10.8536 7.52512L15.0962 11.7678C15.2915 11.963 15.2915 12.2796 15.0962 12.4749L10.8536 16.7175C10.6583 16.9128 10.3417 16.9128 10.1464 16.7175C9.95118 16.5222 9.95118 16.2057 10.1464 16.0104L14.0355 12.1213L10.1464 8.23223C9.95118 8.03697 9.95118 7.72039 10.1464 7.52512Z"
                                fill="currentColor"></path>
                        </svg>
                    </button>
                `
            });

    }

// onload
if(jQuery(window).width() < 768){
slider();

// jQuery('.variant-option__button-label').click(function(){
//     setTimeout(function(){
//         slider();
//     }, 2000);
// })


jQuery(document).on(
  'change',
  'fieldset[data-fieldset-index="0"] input[type="radio"]',
  function () {

    var colSlt = jQuery(this).val().toLowerCase().trim();

    var $gallery = jQuery(this)
      .closest('.product-information__grid')
      .find('.media-gallery__grid');

    if (!$gallery.hasClass('slick-initialized')) return;

    // 🔥 Remove previous filter
    $gallery.slick('slickUnfilter');

    // 🔥 Apply new filter (NO BLANK SLIDES)
    $gallery.slick('slickFilter', function () {
      var colimg = jQuery(this).find('.product-media').attr('data-color');
      colimg = colimg ? colimg.toLowerCase().trim() : '';
      return colimg === '' || colimg === colSlt;
    });

    // Reset to first slide
    $gallery.slick('slickGoTo', 0, true);
  }
);

}


function updateFirstVisible() {
    var $items = jQuery('.media-gallery__grid li:visible');

    jQuery('.media-gallery__grid li').removeClass('is-first');

    if ($items.length) {
        $items.first().addClass('is-first');
    }
}    

var colSlt = null;
var parent = null;
var trigger = null;

// Capture selected color
jQuery(document).on('change', 'fieldset[data-fieldset-index="0"] input[type="radio"]', function () {
    colSlt = jQuery(this).val().toLowerCase().trim();
    console.log('Selected:', colSlt);
    trigger = jQuery(this);
});

// Run gallery filter repeatedly

setInterval(function () {

    if (!colSlt || !trigger) return;

    var $gallery;

    // Check quick add modal visibility
    var isQuickAddVisible = jQuery('.quick-add-modal').is(':visible');

    if (isQuickAddVisible) {
        $gallery = trigger
            .closest('#quick-add-modal-content')
            .find('.media-gallery__grid');
    } else {
        $gallery = trigger
            .closest('.product-information__grid')
            .find('.media-gallery__grid');
    }

    // Safety check
    if (!$gallery.length) return;

    // Filter images
    $gallery.find('li').each(function () {
        var $item = jQuery(this);
        var colimg = $item.find('.product-media').attr('data-color');

        colimg = colimg ? colimg.toLowerCase().trim() : '';

        if (colimg === colSlt || colimg === '') {
            $item.show();
        } else {
            $item.hide();
        }
    });

    updateFirstVisible();

}, 300);


function filterGallery(trigger) {

    if (!trigger || !trigger.length) return;

    var colSlt = trigger.val().toLowerCase().trim();
    var $gallery;

    var isQuickAddVisible = jQuery('.quick-add-modal').is(':visible');

    if (isQuickAddVisible) {
        $gallery = trigger
            .closest('#quick-add-modal-content')
            .find('.media-gallery__grid');
    } else {
        $gallery = trigger
            .closest('.product-information__grid')
            .find('.media-gallery__grid');
    }

    if (!$gallery.length) return;

    $gallery.find('li').each(function () {
        var $item = jQuery(this);
        var colimg = $item.find('.product-media').attr('data-color');

        colimg = colimg ? colimg.toLowerCase().trim() : '';

        if (colimg === colSlt || colimg === '') {
            $item.show();
        } else {
            $item.hide();
        }
    });

    updateFirstVisible();
}

jQuery(document).on(
    'change',
    'fieldset[data-fieldset-index="0"] input[type="radio"]',
    function () {
        filterGallery(jQuery(this));
    }
);

jQuery(document).ready(function () {

    var $default = jQuery(
        'fieldset[data-fieldset-index="0"] input[type="radio"]:checked'
    );

    if ($default.length) {
        filterGallery($default);
    }

});


jQuery('.cursor-pointer').click(function(){
    jQuery('.product-size-chart').show();
})

jQuery('.closeIcon').click(function(){
    jQuery('.product-size-chart').hide();
})

}); //ready function
